
import Vue from 'vue';

export default Vue.extend({
	name: 'UserRating',

	props: {
		currentReviews: {
			type: Object,
			default: () => ({})
		},

		showBackButton: {
			type: Boolean,
			default: false
		}
	}
});
